import  DragSlider  from '../utils/components/dragSlider';
import {BulbModule} from '../core/bulbModule';


export default class extends BulbModule {
    constructor(m) {
        //console.debug('Slider: Constructor')
        super(m);

    }

    init(){
        //console.debug('Slider: Constructor')

        let draggablebar = false;
        if(this.getData('draggablebar')){
            draggablebar = true;
        }

        let getSlide = false;
        if(this.getData('getslide')){
            getSlide = true;
        }

        this.drag = new DragSlider(this.el, {
            inertiaSpeed : 1,
            getSlide : getSlide,
            draggableBar : draggablebar,
        });

        this.bindEvents();

        this.bOn('onEnterViewport', this.play.bind(this))
        this.bOn('onExitViewport', this.pause.bind(this))

        //const drag = new DragSlider('.drag','.drag-slide');
    }

    bindEvents(){
        window.addEventListener( 'resize', this.debouncedHandleResize, false );
    }


    pause(){
        this.drag.pause();
    }

    play(){
        this.drag.play();
    }

    destroy(){
        super.destroy()
        this.drag.destroy();
        window.removeEventListener( 'resize', this.debouncedHandleResize );
    }
}





// WEBPACK FOOTER //
// ./scripts/modules/slider.js